<template>
  <div>
    <div class="filter-container">
      <div class="search-box">
        <h4 class="text-center">المكان</h4>
        <b-form-input v-model="searchCity" placeholder="اسم المدينه"></b-form-input>
      </div>
      <div class="checkbox-container">
        <b-form-checkbox
        v-for="city in searchCityFunction()"
        :id="city.name"
        :key="city.name"
        :name="city.name"
        :value="city.name"
        unchecked-value="not_accepted"
        >
        {{city.name}}
        </b-form-checkbox>
        <p v-if="searchCityFunction() == ''" class="text-center">No Search Resault</p>
      </div>
      <div class="search-box">
        <b-form-input v-model="searchProg" placeholder="التصنيفات"></b-form-input>
      </div>
      <div class="checkbox-container">
        <b-form-checkbox
        v-for="prog in searchProgFunction()"
        :id="prog.name"
        :key="prog.name"
        :name="prog.name"
        :value="prog.name"
        unchecked-value="not_accepted"
        >
        {{prog.name}}
        </b-form-checkbox>
        <p v-if="searchProgFunction() == ''" class="text-center">No Search Resault</p>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script type="text/javascript">

  export default {
    name:'ProgramsConetnt',
    data() {
      return {
        searchCity:'',
        searchProg:'',
        priceRange:[100, 400],
        progs: [
          {
            name:'للإمارات'
          },
          {
            name:'قطر'
          },
          {
            name:'لبنان'
          }
        ],
        cyties:[
          {
            name:'العين السحنه',
          },
          {
            name:'شرم الشيخ',
          },
          {
            name:'الاقصر'
          },
        ]
      }
    },
    methods: {
      //search Programs
      searchProgFunction() {
        var vm = this;
        return this.progs.filter(function(prog){
          return prog.name.indexOf(vm.searchProg) !== -1
        })
      },

      //search city
      searchCityFunction() {
        var vm = this
        return this.cyties.filter(function (city) {
          return city.name.indexOf(vm.searchCity) !== -1
        })
      }
    },
    watch: {
      'searchCity' : function() {
        this.searchCityFunction()
      },
      'searchProg' : function() {
        this.searchProgFunction()
      }
    }
  }
</script>
